namespace('IO.Views.Packages', function (exports) {
  'use strict';

  exports.Clone = IO.Views.Packages.Show;
});
